<template>
  <div class="admissions-total">
    <div class="total-box">
      <p>招生数据</p>
      <div class="total-content flex-wrap">
        <div class="total-num">
          <div class="total-row">
            <div class="total-item">
              <div class="total-icon fn-clear">
                <i class="item-icon fn-left" />
                <span class="fn-left">Leads数</span>
              </div>
              <div class="number">{{ totalData.leads_num }}</div>
            </div>
          </div>
          <div class="total-row">
            <div class="total-item">
              <div class="total-icon fn-clear">
                <i class="item-icon fn-left" />
                <span class="fn-left">约访上门量</span>
              </div>
              <div class="number">{{ totalData.appointment_visit_num }}</div>
            </div>
            <div class="total-item">
              <div class="total-icon fn-clear">
                <i class="item-icon fn-left" />
                <span class="fn-left">上门量</span>
              </div>
              <div class="number">{{ totalData.visit_num }}</div>
            </div>
          </div>
          <div class="total-row">
            <div class="total-item">
              <div class="total-icon fn-clear">
                <i class="item-icon fn-left" />
                <span class="fn-left">新签人数</span>
              </div>
              <div class="number">{{ totalData.through_review_num }}</div>
            </div>
            <div class="total-item">
              <div class="total-icon fn-clear">
                <i class="item-icon fn-left" />
                <span class="fn-left">新签总额</span>
              </div>
              <div class="number">{{ totalData.through_review_price }}</div>
            </div>
          </div>
        </div>
        <div class="total-img">
          <span class="percent one">{{ conversion1 }}%</span>
          <span class="percent two">{{ conversion2 }}%</span>
          <span class="percent three">{{ conversion3 }}%</span>
        </div>
      </div>
    </div>
    <div class="chart-box">
      <p>
        招生趋势
        <span>（以下数据为所选时间段内包含的人工月数据）</span>
      </p>
      <div class="line-wrap flex-wrap">
        <DataLine
          class="line"
          :title="'新签人数'"
          :echarts-data.sync="dataInfo"
          :name="'through_review_num'"
          :legend="'新签人数'"
        />
        <DataLine
          class="line"
          :title="'新签总额'"
          :echarts-data.sync="dataInfo"
          :name="'through_review_price'"
          :legend="'新签总额'"
        />
        <DataLine
          class="line"
          unit="%"
          :title="'上门率'"
          :echarts-data.sync="dataInfo"
          :name="'visit_percent'"
          :legend="'上门率'"
        />
        <DataLine
          class="line"
          unit="%"
          :title="'上门转新签率'"
          :echarts-data.sync="dataInfo"
          :name="'through_review_percent'"
          :legend="'上门转新签率'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataLine from '@/components/chart/DataLine.vue'
export default {
  name: 'AdmissionsTotal',
  components: {
    DataLine
  },
  props: {
    dataInfo: Array,
    totalData: Object
  },
  data() {
    return {}
  },
  computed: {
    conversion1() {
      return this.totalData.leads_num == 0
        ? 0
        : ((this.totalData.visit_num / this.totalData.leads_num) * 100).toFixed(
          2
        )
    },
    conversion2() {
      return this.totalData.leads_num == 0
        ? 0
        : (
          (this.totalData.through_review_num / this.totalData.leads_num) *
            100
        ).toFixed(2)
    },
    conversion3() {
      return this.totalData.visit_num == 0
        ? 0
        : (
          (this.totalData.through_review_num / this.totalData.visit_num) *
            100
        ).toFixed(2)
    }
  },
  watch: {
    dataInfo() {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.admissions-total {
  .total-box {
    margin-bottom: 40px;
    p {
      color: $color_black;
      font-size: 30px;
      margin-bottom: 30px;
    }
    .total-content {
      height: 500px;
      background: #fafafa;
      box-sizing: border-box;
      padding: 50px;
      .total-img {
        width: 540px;
        height: 400px;
        background: url("../../../assets/img/admissions_statistics_total_bg.png")
          no-repeat;
        background-size: 100%;
        position: relative;
        .percent {
          position: absolute;
          color: $color_blue;
          font-size: 14px;
          line-height: 14px;
          &.one {
            left: 403px;
            top: 145px;
          }
          &.two {
            left: 467px;
            top: 205px;
          }
          &.three {
            left: 370px;
            top: 272px;
          }
        }
      }
      .total-num {
        flex: 1;
        .total-row {
          height: 134px;
          box-sizing: border-box;
          border-bottom: solid 1px #d7e0f6;
          display: flex;
          &:nth-child(1) {
            .total-item {
              .total-icon {
                .item-icon {
                  border-color: $color_orange;
                }
              }
            }
          }
          &:nth-child(2) {
            .total-item {
              .total-icon {
                .item-icon {
                  border-color: $color_green;
                }
              }
            }
          }
          &:nth-child(3) {
            .total-item {
              .total-icon {
                .item-icon {
                  border-color: $color_blue;
                }
              }
            }
          }
          .total-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            height: 100%;
            margin-left: 50px;
            .total-icon {
              .item-icon {
                box-sizing: border-box;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                border-width: 3px;
                border-style: solid;
                border-color: #333;
                margin-right: 10px;
              }
              span {
                font-size: 14px;
                line-height: 16px;
                color: $color_black;
              }
            }
            .number {
              font-size: 26px;
              color: $color_blue;
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
  .chart-box {
    p {
      color: $color_black;
      font-size: 30px;
      span {
        font-size: 14px;
      }
    }
    .line-wrap {
      flex-wrap: wrap;
      justify-content: space-between;
      .line {
        margin-top: 40px;
      }
    }
  }
}
</style>
